import type React from "react";

import type { IPageSection, SectionType } from "@/api/interfaces/pageLayout";
import { CmsBlock } from "@/base/components/Global";

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- block types vary per SectionType
type BlockComponent = React.ComponentType<{ block: any }>;

type BlockOverride =
  | ((block: IPageSection, idx: number) => React.ReactNode)
  | null;

type RenderOptions = {
  overrides?: Partial<Record<SectionType, BlockOverride>>;
  firstBlockSmall?: boolean;
};

const renderCmsBlocks = (
  components: IPageSection[],
  registry: Partial<Record<SectionType, BlockComponent>>,
  options?: RenderOptions,
): React.ReactNode[] => {
  const { overrides, firstBlockSmall = true } = options ?? {};

  return components.map((block, idx, arr) => {
    const isLast = idx === arr.length - 1;
    const isSmall = firstBlockSmall && idx === 0;

    if (overrides && block.type in overrides) {
      const override = overrides[block.type];

      if (override === null) return null;

      if (override) {
        return (
          <CmsBlock key={idx} addBreak={!isLast} isSmall={isSmall}>
            {override(block, idx)}
          </CmsBlock>
        );
      }
    }

    const Component = registry[block.type];
    if (!Component) return null;

    return (
      <CmsBlock key={idx} addBreak={!isLast} isSmall={isSmall}>
        <Component block={block} />
      </CmsBlock>
    );
  });
};

export { renderCmsBlocks };
